import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-3f869af9"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "mobile-header__brand",
  href: "/",
  "aria-label": "Startseite"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Timo Rothdeutsch", -1))
const _hoisted_3 = {
  key: 0,
  class: "mobile-header__rail",
  "aria-label": "Abschnitte"
}
const _hoisted_4 = ["href", "aria-label"]
const _hoisted_5 = {
  class: "mobile-header__dock-wrap",
  "aria-label": "Mobile Hauptnavigation"
}
const _hoisted_6 = ["href", "aria-label"]
const _hoisted_7 = { class: "mobile-header__dock-label" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mobile-header__dock-label" }, "Info", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BrandLogo = _resolveComponent("BrandLogo")!
  const _component_MobileSymbolIcon = _resolveComponent("MobileSymbolIcon")!

  return (_openBlock(), _createElementBlock("header", {
    class: _normalizeClass(["mobile-header", {
      'mobile-header--vecura': _ctx.isVecura,
      'mobile-header--bar-hidden': _ctx.isHeaderHidden,
    }])
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["mobile-header__bar", { 'mobile-header__bar--hidden': _ctx.isHeaderHidden }])
    }, [
      _createElementVNode("a", _hoisted_1, [
        _createVNode(_component_BrandLogo, {
          "show-name": false,
          variant: _ctx.isVecura ? 'vecura' : 'default'
        }, null, 8, ["variant"]),
        _hoisted_2
      ])
    ], 2),
    (_ctx.showSectionRail)
      ? (_openBlock(), _createElementBlock("nav", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sectionItems, (item) => {
            return (_openBlock(), _createElementBlock("a", {
              key: item.href,
              class: _normalizeClass([{
          'mobile-header__rail-link--active': _ctx.isSectionActive(item.id),
        }, "mobile-header__rail-link"]),
              href: item.href,
              "aria-label": item.label
            }, null, 10, _hoisted_4))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("nav", _hoisted_5, [
      _createElementVNode("div", {
        class: _normalizeClass(["mobile-header__dock", { 'mobile-header__dock--hidden': _ctx.isDockHidden }])
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.primaryNavItems, (item) => {
          return (_openBlock(), _createElementBlock("a", {
            key: item.href,
            class: _normalizeClass([{
            'mobile-header__dock-link--active': _ctx.isActive(item.href),
          }, "mobile-header__dock-link"]),
            href: item.href,
            "aria-label": item.label
          }, [
            _createVNode(_component_MobileSymbolIcon, {
              type: item.icon
            }, null, 8, ["type"]),
            _createElementVNode("span", _hoisted_7, _toDisplayString(item.label), 1)
          ], 10, _hoisted_6))
        }), 128)),
        _createElementVNode("a", {
          class: _normalizeClass(["mobile-header__dock-link", { 'mobile-header__dock-link--active': _ctx.isMoreActive }]),
          href: "/mehr",
          "aria-label": "Info"
        }, [
          _createVNode(_component_MobileSymbolIcon, { type: "info" }),
          _hoisted_8
        ], 2)
      ], 2)
    ])
  ], 2))
}